import React from 'react';
import { string, number } from 'prop-types';

export default function ProductsHeader({
    columnName1,
    columnName2,
    columnName3,
    itemsLength,
    itemType
}) {
    if (itemsLength <= 0) return null;
    if (itemType !== 'ProductListingTile') return null;
    return (
        <div className="products-header">
            <p>{columnName1}</p>
            <p>{columnName2}</p>
            <p>{columnName3}</p>
        </div>
    );
}

ProductsHeader.propTypes = {
    /* eslint-disable react/no-typos */
    // The disable is needed until https://github.com/yannickcr/eslint-plugin-react/issues/1389 is resolved
    columnName1: string.isRequired,
    columnName2: string.isRequired,
    columnName3: string.isRequired,
    itemsLength: number.isRequired,
    itemType: string.isRequired
    /* eslint-enable react/no-typos */
};
